// Vue
import Vue from 'vue'
import i18n from './i18n'
import App from './App'
// 核心插件
import d2Admin from '@/plugin/d2admin'
// store
import store from '@/store/index'

// 菜单和路由设置
import router from './router'
import {
	frameInRoutes
} from '@/router/routes'

//axios异步请求
import axios from 'axios'
Vue.prototype.$axios = axios

//引入Lodash的js工具库
import _ from 'lodash'
Vue.prototype._ = _

//vxe-table第三方表格
import '@/plugin/vxe-table/index.js'

//引入md5
import md5 from 'js-md5'
Vue.prototype.$md5 = md5

//引入aes加密组件
import cryptoJS from '@/libs/util.cryptoJS.js'
Vue.prototype.$cryptoJS = cryptoJS

//引入剪切板功能
import VueClipboard from 'vue-clipboard2'

//引入cookies组件
import util from '@/libs/util.js'
Vue.prototype.$util = util

// 核心插件
Vue.use(d2Admin)
Vue.use(VueClipboard)

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
	created() {
		// 处理路由 得到每一级的路由设置
		this.$store.commit('d2admin/page/init', frameInRoutes)
		// 设置顶栏菜单
		//this.$store.commit('d2admin/menu/headerSet', menuHeader)
		// 设置侧边栏菜单		
		// this.$store.commit('d2admin/menu/asideSet', menuAside)		
		// 初始化菜单搜索功能
		//this.$store.commit('d2admin/search/init', menuHeader)
	},
	mounted() {
		// 展示系统信息
		this.$store.commit('d2admin/releases/versionShow')
		// 用户登录后,从持久化数据库加载一系列的设置.刷新页面也会触发
		this.$store.dispatch('d2admin/account/load')
		// 获取并记录用户 UA
		this.$store.commit('d2admin/ua/get')
		// 初始化全屏监听
		this.$store.dispatch('d2admin/fullscreen/listen')
	},

}).$mount('#app')
